<template>
	<div class="user">
		<navBar>{{ title }}</navBar>
		<div class="content-box" >
			<div class="navBox font26">
				<div class="item df-sb df-a">
					<p>学生姓名：</p>
					<p>{{ dataObj.username }}</p>
				</div>
				<div class="item df-sb df-a">
					<p>手机号：</p>
					<p>{{dataObj.mobile}}</p>
				</div>
				<div class="item df-sb df-a">
					<p>密码：</p>
					<p>*******</p>
				</div>
				<div class="item df-sb df-a">
					<p>确认密码：</p>
					<div class="xiugai df-mc" @click="goPage('/changePassword')">修改密码</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'userMessage',
	watch: {},
	data() {
		return {
			title: this.$route.query.title || '个人信息',
			dataObj: this.$store.getters['userCenter/getUserInfs']
		};
	},

	created() {
		console.log(this.dataObj);
		// this.nickName = this.userInfs.nickname;
	},
	methods: {
		getNavClass() {
			this.$api
				.getNavClass({
					navid: this.currentId
				})
				.then((res) => {
					let resData = res.data?.data || [];
					this.allRequest = resData.length;

					for (let i = 0; i < resData.length; i++) {
						this.$api
							.getCourseTypeContall({
								coursetypeid: resData[i].id
							})
							.then((res) => {
								this.acount = ++this.acount;
								resData[i].children = res.data || [];
							});
					}

					this.dataList = resData;
				});
		},
		goPage(path) {
			this.$router.push({
				path: path,
				query: {
					id: 45,
					name: 'name',
					active: 1
				}
			});
		}
	}
};
</script>

<style lang="scss" scoped>
.user {
	height: calc(100% - 1.08rem);
	padding: 0.24rem 0rem 0.28rem 0rem;
	position: fixed;
	left: 0;
	right: 0;
	top: 1.08rem;
	overflow: auto;
	background: #f5faff;
	.content-box {
		.navBox {
			width: 100%;
			padding: 0 0.28rem;
			background-color: #ffffff;
			.item {
				height: 0.98rem;
				border-bottom: 1px solid #dcdcdc;
				&:last-child {
					border: none;
				}
				.xiugai {
					width: 1.48rem;
					height: 0.56rem;
					border-radius: 0.28rem;
					border: 1px solid #ff7a32;
					color: #ff7a32;
					font-size: 0.24rem;
				}
			}
		}
	}
}
</style>
